import { render, staticRenderFns } from "./CancellationTable.vue?vue&type=template&id=134563ba&scoped=true"
import script from "./CancellationTable.vue?vue&type=script&lang=js"
export * from "./CancellationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134563ba",
  null
  
)

export default component.exports